document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();

    RelatedHypothesis.init();

    bannerAdSCroll();
});

const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function initHeaderScroll() {
    let scrollStartY = 0;

    // --- DOM ELEMENTS ---
    const header = document.querySelector('.template-header');
    const detailsBar = document.getElementById('details-bar');
    // --- SCROLL HANDLER ---
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;
        const detailsRect = detailsBar.getBoundingClientRect();
        const detailsActive = detailsRect.top <= 76;

        if (isDesktop) {
            if (detailsActive) {
                detailsBar.classList.add('active');

                if (!header?.classList.contains('active-scroll')) {
                    scrollStartY = scrollY;
                }

                header?.classList.add('active-scroll');

                let scrollDelta = scrollY - scrollStartY;
                if (scrollDelta < 0) scrollDelta = 0;
                if (scrollDelta > 120) scrollDelta = 120;
            } else {
                detailsBar.classList.remove('active');
                header?.classList.remove('active-scroll');
                scrollStartY = 0;
            }

            lastScrollY = scrollY <= 0 ? 0 : scrollY;
        }
    });
}

function bannerAdSCroll() {
    const bannerEl = document.querySelector('.banner-article-ads');

    if (!bannerEl) return;
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentY = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;
        if (isDesktop) {
            if (currentY > lastScrollY) {
                bannerEl.classList.add('compact');
            } else {
                bannerEl.classList.remove('compact');
            }
        }
        lastScrollY = currentY <= 0 ? 0 : currentY;
    });
}

const RelatedHypothesis = {
    config: {
        container: '#js-same-tag-container',
        list: '#js-same-tag-list',
        limit: 10,
    },

    state: {
        currentHandle: window.location.pathname.split('/').pop(),
        currentType: window.__hypothesisType,
    },

    init() {
        if (!this.state.currentType) return;

        this.api.fetch();
    },

    api: {
        async fetch() {
            const { api, ui, helpers } = RelatedHypothesis;

            try {
                const url = api.buildUrl();
                const data = await api.request(url);
                const products = api.parseProducts(data);

                if (!products.length) return;

                ui.render(products);
                helpers.show();
                helpers.initSwiper();
            } catch (error) {
                console.error(error);
            }
        },

        buildUrl() {
            const { config, state } = RelatedHypothesis;

            const query = `product_type:"${state.currentType}" AND tag:hypothesis`;

            return (
                `/search/suggest.json?q=${encodeURIComponent(query)}` +
                `&resources[type]=product&resources[limit]=${config.limit}`
            );
        },

        async request(url) {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`);
            }

            return response.json();
        },

        parseProducts(data) {
            return RelatedHypothesis.helpers.filterProducts(
                data.resources?.results?.products || []
            );
        },
    },

    helpers: {
        filterProducts(products) {
            return products.filter(item => item.handle !== RelatedHypothesis.state.currentHandle);
        },

        // Resize ảnh qua Shopify CDN bằng query params (width/height/crop)
        imgUrl(url, width, height, crop = 'center') {
            if (!url) return '';

            try {
                const u = new URL(url);
                if (width) u.searchParams.set('width', width);
                if (height) u.searchParams.set('height', height);
                if (crop) u.searchParams.set('crop', crop);
                return u.toString();
            } catch (e) {
                return url;
            }
        },

        show() {
            document.querySelector(RelatedHypothesis.config.container)?.classList.remove('hidden');
        },

        initSwiper() {
            const { container } = RelatedHypothesis.config;

            new Swiper(`${container} .swiper-container`, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                loop: true,

                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },

                pagination: {
                    el: `${container} .swiper-pagination`,
                    clickable: true,
                },

                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16,

                        pagination: false,
                        navigation: {
                            nextEl: `${container} .swiper-button-next`,
                            prevEl: `${container} .swiper-button-prev`,
                        },
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 20,

                        pagination: false,
                        navigation: {
                            nextEl: `${container} .swiper-button-next`,
                            prevEl: `${container} .swiper-button-prev`,
                        },
                    },
                },
            });
        },

        recommendIcon() {
            return `
                <span class="w-4 h-4 block"> <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"> <path fill-rule="evenodd" d="M12.539 14.57a9.25 9.25 0 0 1-4.074-.838l-.307-.141a3.751 3.751 0 0 0-1.158-.32v-5.222a1.5 1.5 0 0 0 .15-.099 6.489 6.489 0 0 0 2.475-3.95 1.41 1.41 0 0 1 1.378 1.557l-.133 1.26a1.75 1.75 0 0 0 1.74 1.933h1.595c.758 0 1.342.67 1.239 1.42l-.338 2.449a2.25 2.25 0 0 1-2.176 1.942l-.391.01Zm-7.039-6.32h-1v5h1v-5Zm2.34 6.845a10.75 10.75 0 0 0 4.735.975l.391-.01a3.75 3.75 0 0 0 3.626-3.236l.337-2.448a2.75 2.75 0 0 0-2.724-3.126h-1.594a.25.25 0 0 1-.249-.276l.133-1.26a2.91 2.91 0 0 0-2.894-3.214h-.364c-.5 0-.928.357-1.017.849l-.055.303a4.989 4.989 0 0 1-1.915 3.098h-2c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56-1.25 1.25-1.25h2.345c.324 0 .644.07.938.205l.307.14Z"></path> </svg> </span>
            `;
        },
    },

    ui: {
        tagsHtml(tags) {
            if (!tags || !tags.length) return '';

            const badges = tags.map(tag => {
                const isRecommend = tag === 'Recommend';

                return `
                    <div class="tpl-card__badge ${isRecommend ? '!order-[0]' : ''}">
                        ${isRecommend ? RelatedHypothesis.helpers.recommendIcon() : ''}
                        <span>${tag}</span>
                    </div>
                `;
            }).join('');

            return `<div class="tpl-card__tags">${badges}</div>`;
        },

        card(product) {
            const { ui, helpers } = RelatedHypothesis;

            const imageUrl = product.featured_image?.url || product.image || '';
            const title = product.title || '';
            const handle = product.handle || '';
            const type = product.type || '';

            const imageHtml = imageUrl
                ? ` <div class="w-full relative">
                        <img src="${helpers.imgUrl(imageUrl, 1000, 1250, 'top')}"
                            loading="lazy"
                            alt="${title}"
                            class="absolute inset-0 object-cover object-top m-auto" />
                    </div>`
                : '';

            return `
                <div class="swiper-slide">
                    <article class="tpl-card">
                        <div class="tpl-card__thumb !bg-white !border-0">
                            ${ui.tagsHtml(product.tags)}

                            ${imageHtml}

                            <div class="tpl-card__hover">
                                <a href="/pages/hypothesis/${handle}" class="tpl-card__use">
                                    <span>View Details</span>

                                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h10"></path><path d="M9 4l4 4-4 4"></path></svg>
                                </a>
                            </div>
                        </div>

                        <div class="tpl-card__body">
                            <a href="/pages/hypothesis/${handle}">
                                <h3 class="tpl-card__title">${title}</h3>
                            </a>

                            <div class="tpl-card__body-row"><span>${type}</span></div>
                        </div>
                    </article>
                </div>
            `;
        },

        render(products) {
            const { config, ui } = RelatedHypothesis;

            const list = document.querySelector(config.list);

            if (!list) return;

            list.innerHTML = products.map(ui.card).join('');
        }
    },
};